import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { MaskLines, Em, Eyebrow } from "@/components/site/Motion";
import { POSITIONS } from "@/lib/site";

const Row = ({ p, i }) => (
  <motion.li initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay: i * 0.05 }} className="group relative border-t border-[#0E0E10]" data-testid={`position-row-${i}`}>
    <span className="absolute inset-0 origin-bottom scale-y-0 bg-[#0E0E10] transition-transform duration-500 ease-out group-hover:scale-y-100" />
    <Link to="/clients" className="relative grid gap-3 px-2 py-6 transition-colors duration-300 group-hover:text-[#F1ECE2] md:grid-cols-12 md:items-center md:py-8">
      <span className="font-mono-x text-xs md:col-span-1">0{i + 1}</span>
      <span className="font-display text-3xl font-bold tracking-[-0.03em] transition-transform duration-500 group-hover:translate-x-3 sm:text-5xl md:col-span-6">{p.name}</span>
      <span className="text-sm leading-relaxed md:col-span-4">{p.note}</span>
      <ArrowUpRight className="hidden h-8 w-8 justify-self-end transition-transform duration-500 group-hover:rotate-45 group-hover:text-[#FF4D1A] md:col-span-1 md:block" />
    </Link>
  </motion.li>
);

export const Positions = () => (
  <section className="px-5 py-24 sm:px-8 lg:py-36" data-testid="positions-section">
    <div className="mx-auto max-w-[1400px]">
      <div className="mb-14 grid gap-8 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Eyebrow className="text-[#c2380f]">positions we play</Eyebrow>
          <MaskLines as="h2" lines={["every position", <>on the <Em>tech field.</Em></>]}
            className="font-display mt-6 text-4xl font-bold leading-[0.95] tracking-[-0.03em] sm:text-6xl" />
        </div>
        <p className="self-end text-base leading-relaxed text-[#3d3a35] md:text-lg lg:col-span-4 lg:col-start-9">
          Contract, contract-to-hire or permanent. One specialist or a whole squad. If it runs on code, cloud or data, we know who's good at it.
        </p>
      </div>
      <ul className="border-b border-[#0E0E10]">{POSITIONS.map((p, i) => <Row key={p.name} p={p} i={i} />)}</ul>
    </div>
  </section>
);
